import type { Router } from 'vue-router';

import type { useDoorsaleStore } from '@/stores/doorsaleStore';

export function advanceDoorsaleEvent(
	router: Router,
	doorsaleStore: ReturnType<typeof useDoorsaleStore>,
	currentEventId: number | string,
): void {
	const ids = doorsaleStore.selectedEventIds;
	const pos = ids.indexOf(currentEventId);
	if (pos < ids.length - 1) {
		router.push({ name: 'doorsale-tickets', params: { eventId: ids[pos + 1] } });
	} else {
		router.push({ name: 'doorsale-information' });
	}
}
